<template>
    <div>
        <Loader v-if="isLoading"></Loader>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-client-page-heading">
                    <h3 class="fw-bold">{{ Cliente.cliId ? 'Alterar cliente' : 'Novo cliente' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Clientes</a>
                        </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ Cliente.cliId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-body">
                                <v-tabs v-model="tab" class="gp-client-tabs" color="#102a5a" show-arrows>
                                    <v-tab value="dados" class="tabinfo"
                                        style="font-size: 13px;text-transform: none !important;">
                                        <v-icon size="16">mdi-account-outline</v-icon> Dados Cliente
                                    </v-tab>
                                    <div v-if="Cliente.cliId != 0 && Cliente.tpdId == 1 && isCheckedConjuge">
                                        <v-tab value="conjuge" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">
                                            <v-icon size="16">mdi-account-heart-outline</v-icon> Cônjuge
                                        </v-tab>
                                    </div>
                                    <div v-if="Cliente.cliId != 0 && isCheckedCorresponsvel">
                                        <v-tab value="corresponsavel" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">
                                            <v-icon size="16">mdi-account-multiple-outline</v-icon> Corresponsável 1
                                        </v-tab>
                                    </div>
                                    <div v-if="Cliente.cliId != 0 && isCheckedCorresponsvel">
                                        <v-tab value="corresponsavel2" class="tabinfo"
                                            style="font-size: 13px;text-transform: none !important;">
                                            <v-icon size="16">mdi-account-multiple-outline</v-icon> Corresponsável 2
                                        </v-tab>
                                    </div>

                                </v-tabs>
                                <v-window v-model="tab">
                                    <v-window-item value="dados">
                                        <div class="gp-client-detail-stack">
                                        <section class="gp-detail-block">
                                            <header class="gp-detail-block-header">
                                                <span class="gp-detail-block-icon"><v-icon size="19">mdi-account-outline</v-icon></span>
                                                <div>
                                                    <h4>Dados cadastrais</h4>
                                                    <p>Informações principais e identificação do cliente.</p>
                                                </div>
                                            </header>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="User.garid == 0">
                                                        <div class="form-group">
                                                            <label>Garantidora</label>
                                                            <v-autocomplete v-model="Cliente.garId"
                                                                :items="garantidorasParaFiltro" item-title="garNomeEmpresa"
                                                                item-value="garId" density="compact" variant="outlined"
                                                                placeholder="Digite para pesquisar" clearable hide-details
                                                                no-data-text="Nenhuma garantidora encontrada"
                                                                @update:model-value="Cliente.imoId = null; BuscaImobiliarias()" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4"
                                                        v-if="User.garid == 0 || User.tpeid == 1">
                                                        <div class="form-group">
                                                            <label>Imobiliaria</label>
                                                            <v-autocomplete v-model="Cliente.imoId"
                                                                :items="imobiliariasFormulario" item-title="imoNomeEmpresa"
                                                                item-value="imoId" density="compact" variant="outlined"
                                                                :disabled="!Cliente.garId"
                                                                :placeholder="Cliente.garId ? 'Digite para pesquisar' : 'Selecione a garantidora'"
                                                                clearable hide-details no-data-text="Nenhuma imobiliária encontrada" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Tipo Pessoa</label>
                                                            <select v-model="Cliente.tpdId"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="optionTipo in TiposDocumentos"
                                                                    :key="optionTipo.tpdId" :value="optionTipo.tpdId">{{
                                                                    optionTipo.tpdNome }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Nº {{ Cliente.tpdId == 1 ? 'CPF' : 'CNPJ' }}</label>
                                                            <input v-model="Cliente.cliDocumento" type="text"
                                                                v-mask="documentoMask" class="form-control"
                                                                @input="NormalizaDocumentoPessoa(Cliente, 'cliDocumento')"
                                                                :placeholder="Cliente.tpdId == 1 ? 'CPF' : 'CNPJ'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome</label>
                                                            <input v-model="Cliente.cliNomeEmpresa" type="text"
                                                                class="form-control"
                                                                :placeholder="Cliente.tpdId == 2 ? 'Nome Fantasia' : 'Nome'" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>E-mail</label>
                                                            <input v-model="Cliente.cliEmail" type="text"
                                                                class="form-control" placeholder="E-mail" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Nome Responsável</label>
                                                            <input v-model="Cliente.cliResponsavel" type="text"
                                                                class="form-control" placeholder="Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>CPF Responsável</label>
                                                            <input v-model="Cliente.cliCampoExtra1" type="text"
                                                                v-mask="'###.###.###-##'" class="form-control"
                                                                placeholder="CPF Responsável" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5" v-if="Cliente.tpdId == 2">
                                                        <div class="form-group">
                                                            <label>Razão Social</label>
                                                            <input v-model="Cliente.cliRazaoSocial" type="text"
                                                                class="form-control" placeholder="Razão Social" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Telefone</label>
                                                            <input v-model="Cliente.cliTelefone"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Whatsapp</label>
                                                            <input v-model="Cliente.cliWhatsapp"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>

                                                    <div class="col-md-2 col-lg-2" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimento" type="date"
                                                                class="form-control" placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Nome do Pai</label>
                                                            <input v-model="Cliente.cliNomePai" type="text"
                                                                class="form-control" placeholder="Nome do Pai" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Nome da Mãe</label>
                                                            <input v-model="Cliente.cliNomeMae" type="text"
                                                                class="form-control" placeholder="Nome da Mãe" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Estado Civil</label>
                                                            <select v-model="Cliente.cliEstadoCivil"
                                                                class="form-select form-control"
                                                                @change="ValidaEstado()">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="(optionTipo, index) in TiposEstadosCivis"
                                                                    :key="index" :value="optionTipo.value">{{
                                                                    optionTipo.value }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="Cliente.tpdId == 1">
                                                        <div class="form-group">
                                                            <label>Renda Mensal Familiar</label>
                                                            <input v-model="Cliente.cliCampoExtra2" type="text"
                                                                class="form-control" placeholder="Renda Mensal" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label
                                                                style="margin-right: 10px;font-size: 14px;margin-top:40px;">Possui
                                                                Corresponsável</label>
                                                            <input type="checkbox" v-model="isCheckedCorresponsvel" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                        <template v-if="Cliente.cliId != 0">
                                        <section class="gp-detail-block">
                                            <header class="gp-detail-block-header">
                                                <span class="gp-detail-block-icon"><v-icon size="19">mdi-map-marker-outline</v-icon></span>
                                                <div>
                                                    <h4>Endereço contratual</h4>
                                                    <p>Endereço utilizado no contrato de garantia.</p>
                                                </div>
                                            </header>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Endereco.cleId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Cliente</label>
                                                            <input v-model="Endereco.cliId" type="text"
                                                                class="form-control" placeholder="Id Cliente" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CEP</label>
                                                            <input v-model="Endereco.cleCep" v-mask="'#####-###'"
                                                                type="text" class="form-control" placeholder="CEP" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group" style="padding-top: 35px;">
                                                            <button type="button" class="btn btn-info"
                                                                @click.prevent="Buscacep(Endereco.cleCep)"
                                                                style="color:#ffffff;">
                                                                Verificar CEP
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-5 col-lg-5" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Endereço</label>
                                                            <input v-model="Endereco.cleEndereco" type="text"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Número</label>
                                                            <input v-model="Endereco.cleNumero" type="number"
                                                                class="form-control" placeholder="Endereço" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Complemento</label>
                                                            <input v-model="Endereco.cleComplemento" type="text"
                                                                class="form-control" placeholder="Complemento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Estado</label>
                                                            <input v-model="Endereco.cleEstado" type="text"
                                                                class="form-control" placeholder="Estado" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Cidade</label>
                                                            <input v-model="Endereco.cleCidade" type="text"
                                                                class="form-control" placeholder="Cidade" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4" v-if="showend">
                                                        <div class="form-group">
                                                            <label>Bairro</label>
                                                            <input v-model="Endereco.cleBairro" type="text"
                                                                class="form-control" placeholder="Bairro" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>

                                        <section class="gp-detail-block">
                                            <header class="gp-detail-block-header">
                                                <span class="gp-detail-block-icon gp-detail-doc-icon"><v-icon size="19">mdi-file-document-outline</v-icon></span>
                                                <div>
                                                    <h4>Documentos do cliente</h4>
                                                    <p>Adicione arquivos JPG, JPEG, PNG ou PDF.</p>
                                                </div>
                                            </header>
                                            <div class="gp-detail-block-body">
                                                <div class="gp-doc-upload">
                                                    <div class="gp-doc-name">
                                                        <label>Nome do documento</label>
                                                        <input v-model="Docs.cdsNomeDoc" type="text" class="form-control"
                                                            placeholder="Ex.: Documento de identificação" />
                                                    </div>
                                                    <div class="gp-doc-file">
                                                        <label>Arquivo</label>
                                                        <v-file-input v-model="selectedFile" label="Selecione o arquivo"
                                                            density="compact" variant="outlined" hide-details
                                                            prepend-inner-icon="mdi-paperclip" prepend-icon=""
                                                            accept="image/*,application/pdf" />
                                                    </div>
                                                    <button type="button" class="btn btn-info gp-doc-add" @click="adicionarDocumentoNaMemoria">
                                                        <v-icon size="16">mdi-plus</v-icon> Adicionar
                                                    </button>
                                                </div>

                                                <div v-if="DocumentosPendentes.length" class="gp-doc-pending">
                                                    <div class="gp-doc-pending-title"><v-icon size="17">mdi-clock-outline</v-icon> Aguardando o salvamento</div>
                                                    <article v-for="(item, index) in DocumentosPendentes" :key="`${item.arquivo.name}-${index}`" class="gp-doc-item">
                                                        <span class="gp-doc-item-icon"><v-icon size="19">mdi-file-clock-outline</v-icon></span>
                                                        <div class="gp-doc-item-info"><strong>{{ item.nome }}</strong><small>{{ item.arquivo.name }}</small></div>
                                                        <div class="gp-doc-item-actions">
                                                            <button type="button" class="gp-doc-delete" title="Remover da lista" @click="removerDocumentoDaMemoria(index)">
                                                                <v-icon size="17">mdi-trash-can-outline</v-icon>
                                                            </button>
                                                        </div>
                                                    </article>
                                                </div>

                                                <div v-if="ListaDocs.length" class="gp-doc-list">
                                                    <article v-for="item in ListaDocs" :key="item.cdsId" class="gp-doc-item">
                                                        <span class="gp-doc-item-icon"><v-icon size="19">mdi-file-outline</v-icon></span>
                                                        <div class="gp-doc-item-info">
                                                            <strong>{{ item.cdsNomeDoc }}</strong>
                                                            <small>Cadastrado em {{ formattedDate(item.cdsDataCadastro) }}</small>
                                                        </div>
                                                        <div class="gp-doc-item-actions">
                                                            <button v-if="item.cdsUrlDoc" type="button" title="Visualizar"
                                                                @click.prevent="VisualizarDocumento(item)">
                                                                <v-icon size="17">mdi-eye-outline</v-icon>
                                                            </button>
                                                            <button v-if="User.tpeid != 3" type="button" class="gp-doc-delete"
                                                                title="Excluir" @click.prevent="DeleteDocumento(item)">
                                                                <v-icon size="17">mdi-trash-can-outline</v-icon>
                                                            </button>
                                                        </div>
                                                    </article>
                                                </div>
                                                <div v-else class="gp-doc-empty">
                                                    <v-icon size="22">mdi-file-hidden</v-icon>
                                                    <span>Nenhum documento cadastrado.</span>
                                                </div>
                                            </div>
                                        </section>
                                        </template>
                                        </div>
                                    </v-window-item>
                                    <!--Conjuge-->
                                    <v-window-item value="conjuge">
                                        <section class="gp-detail-block gp-related-block">
                                        <div class="gp-detail-block-header">
                                            <span class="gp-detail-block-icon"><v-icon size="19">mdi-account-heart-outline</v-icon></span>
                                            <div><h4>Dados do cônjuge</h4><p>Preencha as informações pessoais, de contato e endereço do cônjuge.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome Conjuge</label>
                                                            <input v-model="Cliente.cliNomeConjuge" type="text"
                                                                class="form-control" placeholder="Nome" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CPF Conjuge</label>
                                                            <input v-model="Cliente.cliCpfConjuge"
                                                                v-mask="'###.###.###-##'" type="text"
                                                                class="form-control" placeholder="CPF" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Telefone Conjuge</label>
                                                            <input v-model="Cliente.cliTelefoneConjuge"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Whatsapp Conjuge</label>
                                                            <input v-model="Cliente.cliWhatsappConjuge"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Email Conjuge</label>
                                                            <input v-model="Cliente.cliEmailConjuge" type="text"
                                                                class="form-control" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimentoConjuge"
                                                                type="date" class="form-control"
                                                                placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Endereço completo: *(logradouro, número, bairro,
                                                                cidade, estado e cep)</label>
                                                            <ckeditor :editor="editor" @ready="onReady"
                                                                v-model="Cliente.cliTexto1" :config="$ckconfig">
                                                            </ckeditor>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                    </v-window-item>
                                    <!--Conjuge-->
                                    <!--Corresponsavel 1-->
                                    <v-window-item value="corresponsavel">
                                        <section class="gp-detail-block gp-related-block">
                                        <div class="gp-detail-block-header">
                                            <span class="gp-detail-block-icon"><v-icon size="19">mdi-account-multiple-outline</v-icon></span>
                                            <div><h4>Dados do corresponsável 1</h4><p>Preencha as informações pessoais, familiares, de contato e endereço.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome Corresponsável</label>
                                                            <input v-model="Cliente.cliNomeCorresponsavel" type="text"
                                                                class="form-control" placeholder="Nome" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CPF Corresponsável</label>
                                                            <input v-model="Cliente.cliCpfCorresponsavel"
                                                                v-mask="'###.###.###-##'" type="text"
                                                                class="form-control" placeholder="CPF" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Telefone Corresponsável</label>
                                                            <input v-model="Cliente.cliTelefoneCorresponsavel"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Whatsapp Corresponsável</label>
                                                            <input v-model="Cliente.cliWhatsappCorresponsavel"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Email Corresponsável</label>
                                                            <input v-model="Cliente.cliEmailCorresponsavel" type="text"
                                                                class="form-control" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimentoCorresponsavel"
                                                                type="date" class="form-control"
                                                                placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome do Pai</label>
                                                            <input v-model="Cliente.cliNomePaiCorresponsavel"
                                                                type="text" class="form-control"
                                                                placeholder="Nome do Pai" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome da Mãe</label>
                                                            <input v-model="Cliente.cliNomeMaeCorresponsavel"
                                                                type="text" class="form-control"
                                                                placeholder="Nome da Mãe" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Estado Civil</label>
                                                            <select v-model="Cliente.cliEstadoCivilCorresponsavel"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="(optionTipo, index) in TiposEstadosCivis"
                                                                    :key="index" :value="optionTipo.value">{{
                                                                    optionTipo.value }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Endereço completo: *(logradouro, número, bairro,
                                                                cidade, estado e cep)</label>
                                                            <ckeditor :editor="editor" @ready="onReady"
                                                                v-model="Cliente.cliTexto2" :config="$ckconfig">
                                                            </ckeditor>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                    </v-window-item>
                                    <!--Corresponsavel 1-->
                                    <!--Corresponsavel 2-->
                                    <v-window-item value="corresponsavel2">
                                        <section class="gp-detail-block gp-related-block">
                                        <div class="gp-detail-block-header">
                                            <span class="gp-detail-block-icon"><v-icon size="19">mdi-account-multiple-plus-outline</v-icon></span>
                                            <div><h4>Dados do corresponsável 2</h4><p>Preencha as informações pessoais, familiares, de contato e endereço.</p></div>
                                        </div>
                                        <v-form>
                                            <v-container>
                                                <div class="row">
                                                    <div class="col-md-4 col-lg-4" v-show="false">
                                                        <div class="form-group">
                                                            <label>Idenficador</label>
                                                            <input v-model="Cliente.cliId" type="text"
                                                                class="form-control" placeholder="Id" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome Corresponsável</label>
                                                            <input v-model="Cliente.cliNomeCorresponsavel2" type="text"
                                                                class="form-control" placeholder="Nome" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>CPF Corresponsável</label>
                                                            <input v-model="Cliente.cliCpfCorresponsavel2"
                                                                v-mask="'###.###.###-##'" type="text"
                                                                class="form-control" placeholder="CPF" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Telefone Corresponsável</label>
                                                            <input v-model="Cliente.cliTelefoneCorresponsavel2"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Telefone" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Whatsapp Corresponsável</label>
                                                            <input v-model="Cliente.cliWhatsappCorresponsavel2"
                                                                v-mask="'(##) ####-#####'" type="text"
                                                                class="form-control" placeholder="Whatsapp" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Email Corresponsável</label>
                                                            <input v-model="Cliente.cliEmailCorresponsavel2" type="text"
                                                                class="form-control" placeholder="Email" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-2 col-lg-2">
                                                        <div class="form-group">
                                                            <label>Data Nascimento</label>
                                                            <input v-model="Cliente.cliDataNascimentoCorresponsavel2"
                                                                type="date" class="form-control"
                                                                placeholder="Data Nascimento" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome do Pai</label>
                                                            <input v-model="Cliente.cliNomePaiCorresponsavel2"
                                                                type="text" class="form-control"
                                                                placeholder="Nome do Pai" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-4 col-lg-4">
                                                        <div class="form-group">
                                                            <label>Nome da Mãe</label>
                                                            <input v-model="Cliente.cliNomeMaeCorresponsavel2"
                                                                type="text" class="form-control"
                                                                placeholder="Nome da Mãe" />
                                                        </div>
                                                    </div>
                                                    <div class="col-md-3 col-lg-3">
                                                        <div class="form-group">
                                                            <label>Estado Civil</label>
                                                            <select v-model="Cliente.cliEstadoCivilCorresponsavel2"
                                                                class="form-select form-control">
                                                                <option :value=null>Selecione</option>
                                                                <option v-for="(optionTipo, index) in TiposEstadosCivis"
                                                                    :key="index" :value="optionTipo.value">{{
                                                                    optionTipo.value }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-12 col-lg-12">
                                                        <div class="form-group">
                                                            <label>Endereço completo: *(logradouro, número, bairro,
                                                                cidade, estado e cep)</label>
                                                            <ckeditor :editor="editor" @ready="onReady"
                                                                v-model="Cliente.cliTexto3" :config="$ckconfig">
                                                            </ckeditor>
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-container>
                                        </v-form>
                                        </section>
                                    </v-window-item>
                                    <!--Corresponsavel 2-->
                                </v-window>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-client-main-actions">
                        <button v-if="Cliente.cliId != 0" type="button" class="btn btn-success" style="color:#ffffff;"
                            @click="Put()" :disabled="isSubmittingPut">
                            <v-icon size="16">mdi-content-save-outline</v-icon> Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()"
                            :disabled="isSubmittingAdd">
                            <v-icon size="16">mdi-content-save-outline</v-icon> Salvar
                        </button>
                        <a href="#" @click="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de Cliente</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="gp-client-filters">
                                    <div class="gp-client-filter gp-filter-3" v-if="User.garid == 0">
                                        <label>Garantidora</label>
                                        <v-autocomplete v-model="filtroGarantidora" :items="garantidorasParaFiltro"
                                            item-title="garNomeEmpresa" item-value="garId" density="compact"
                                            variant="outlined" placeholder="Digite para pesquisar" clearable hide-details
                                            no-data-text="Nenhuma garantidora encontrada"
                                            @update:model-value="garantidoraFiltroAlterada" />
                                    </div>
                                    <div class="gp-client-filter gp-filter-3" v-if="User.tpeid != 3">
                                        <label>Imobiliária</label>
                                        <v-autocomplete v-model="filtroImobiliaria" :items="imobiliariasParaFiltro"
                                            item-title="imoNomeEmpresa" item-value="imoId" density="compact"
                                            variant="outlined" :disabled="!filtroGarantidora"
                                            :placeholder="filtroGarantidora ? 'Digite para pesquisar' : 'Selecione a garantidora'"
                                            clearable hide-details no-data-text="Nenhuma imobiliária encontrada" />
                                    </div>
                                    <div class="gp-client-filter gp-filter-3">
                                        <label>Nome</label>
                                        <input v-model.trim="filtroNome" type="text" class="form-control" placeholder="Nome do cliente" />
                                    </div>
                                    <div class="gp-client-filter gp-filter-3">
                                        <label>Documento</label>
                                        <input v-model.trim="filtroDocumento"
                                            v-mask="['###.###.###-##', '##.###.###/####-##']"
                                            type="text" inputmode="numeric" class="form-control" placeholder="CPF ou CNPJ" />
                                    </div>
                                    <div class="gp-client-filter gp-filter-3">
                                        <label>WhatsApp</label>
                                        <input v-model.trim="filtroWhatsapp" v-mask="'(##) ####-#####'"
                                            type="text" inputmode="numeric" class="form-control" placeholder="(00) 00000-0000" />
                                    </div>
                                    <div class="gp-client-filter gp-filter-3">
                                        <label>Telefone</label>
                                        <input v-model.trim="filtroTelefone" v-mask="'(##) ####-#####'"
                                            type="text" inputmode="numeric" class="form-control" placeholder="(00) 00000-0000" />
                                    </div>
                                    <div class="gp-client-filter gp-filter-4">
                                        <label>E-mail</label>
                                        <input v-model.trim="filtroEmail" type="text" class="form-control" placeholder="E-mail" />
                                    </div>
                                    <div class="gp-client-filter-action gp-filter-2">
                                        <button type="button" class="btn btn-outline-secondary" @click="limparFiltros">
                                            <i class="fas fa-eraser"></i> Limpar
                                        </button>
                                    </div>
                                </div>
                                <div class="gp-client-grid-toolbar">
                                    <div class="gp-client-filter-result">{{ clientesFiltrados.length }} cliente(s) encontrado(s)</div>
                                    <button type="button" class="btn gp-export-button" :disabled="!clientesFiltrados.length"
                                        @click="exportarClientesExcel">
                                        <v-icon size="16">mdi-microsoft-excel</v-icon> Exportar Excel
                                    </button>
                                </div>
                                <garante-pay-data-table :headers="headers" :items="clientesFiltrados" v-model="itemsSelected"
                                    alternating theme-color="#364f66" table-class-name="customize-table"
                                    header-text-direction="center" body-text-direction="center"
                                    rows-per-page-message="Linhas por pagina">
                                    <template #item-garId="item">
                                        <span>{{ nomeGarantidora(item.garId) }}</span>
                                    </template>
                                    <template #item-imoId="item">
                                        <span>{{ nomeImobiliaria(item.imoId) }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions">
                                            <button type="button" class="gp-table-action gp-action-edit" title="Editar"
                                                @click="EditGrid(item)">
                                                <v-icon size="17">mdi-pencil-outline</v-icon>
                                            </button>
                                            <button type="button" class="gp-table-action gp-action-delete" title="Excluir"
                                                v-if="User != '' && User.garid == 0" @click="DeleteGrid(item)">
                                                <v-icon size="17">mdi-trash-can-outline</v-icon>
                                            </button>
                                        </div>
                                    </template>
                                </garante-pay-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>
import axios from 'axios';
import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import moment from 'moment'
import { cpf } from 'cpf-cnpj-validator'
import Loader from '../../components/PageLoader.vue'


export default {
    name: 'ClientesView',
    components: {
        moment,
        Loader
    },
    data: () => ({
        isLoading: false,
        EditView: false,
         User: {
            garid:0,
            tpeid:0,
            pesid:0,
            cusid:0
        },
        ListGarantidorasGeral: [],
        ListParceirosGeral: [],
        ListImobiliariasGeral: [],
        ListImobiliarias: [],
        editor: DecoupledEditor,
        tab: null,
        searchValue: '',
        filtroGarantidora: null,
        filtroImobiliaria: null,
        filtroNome: '',
        filtroDocumento: '',
        filtroWhatsapp: '',
        filtroTelefone: '',
        filtroEmail: '',
        itemsSelected: [],
        NomeTela: 'Clientes',
        InfoTela: 'Lista de Clientes',
        MostraGrid: true,
        headers: [],
        isSubmittingAdd: false,
        isSubmittingPut: false,
        //dados
        Cliente: {
            cliId: 0,
            cliVisivel: null,
            cliDataCadastro: null,
            cliNomeEmpresa: '',
            cliRazaoSocial: '',
            tpdId: null,
            cliDocumento: '',
            cliTelefone: '',
            cliWhatsapp: '',
            cliResponsavel: '',
            cliEmail: '',
            cliAtivo: null,
            cliDataAniversario: null,
            cliCampoExtra1: '',
            cliCampoExtra2: '',
            cliCampoExtra3: '',
            cliCampoExtra4: '',
            cliCampoExtra5: '',
            cliTexto1: '',
            cliTexto2: '',
            cliTexto3: '',
            cliData1: null,
            cliData2: null,
            garId: null,
            imoId: null,
            cliNomePai: '',
            cliNomeMae: '',
            cliNomeConjuge: '',
            cliCpfConjuge: '',
            cliTelefoneConjuge: '',
            cliWhatsappConjuge: '',
            cliEmailConjuge: '',
            cliNomeCorresponsavel: '',
            cliCpfCorresponsavel: '',
            cliTelefoneCorresponsavel: '',
            cliWhatsappCorresponsavel: '',
            cliEmailCorresponsavel: '',
            cliDataNascimento: '',
            cliDataNamentoConjuge: '',
            cliEstadoCivil: null,
            cliDataNascimentoCorresponsavel: '',
            cliEstadoCivilCorresponsavel: null,
            cliNomePaiCorresponsavel: '',
            cliNomeMaeCorresponsavel: '',
            cliNomeCorresponsavel2: '',
            cliCpfCorresponsavel2: '',
            cliTelefoneCorresponsavel2: '',
            cliWhatsappCorresponsavel2: '',
            cliEmailCorresponsavel2: '',
            cliDataNascimentoCorresponsavel2: '',
            cliEstadoCivilCorresponsavel2: null,
            cliNomePaiCorresponsavel2: '',
            cliNomeMaeCorresponsavel2: '',
        },
        ListClientes: [],
        ListClientesGeral: [],
        TiposDocumentos: [],
        TiposEstadosCivis: [{ value: 'Casado(a)' }, { value: 'Solteiro(a)' }, { value: 'Divorciado(a)' }, { value: 'União Estável' }, { value: 'Viúvo(a)' }],
        //dados
        //imagens
        //endereco
        Endereco: {
            cleId: 0,
            grtId: 0,
            cdtId: 0,
            cleEndereco: '',
            cleNumero: 0,
            cleComplemento: '',
            cleObsEndereco: '',
            cleCep: '',
            clePais: '',
            cleEstado: '',
            cleCidade: '',
            cleBairro: '',
            cleCodigoDistrito: '',
            cliId: null
        },
        ListaEnderecos: [],
        showend: false,
        Retornocep: null,
        //endereco
        //docs
        Docs: {
            cdsId: 0,
            grtId: 0,
            cdtId: 0,
            cliId: null,
            cdsNomeDoc: '',
            cdsUrlDoc: '',
            cdsUser: '',
            cdsDataCadastro: ''
        },
        ListaDocs: [],
        selectedFile: [],
        DocumentosPendentes: [],
        showdocs: false,
        //docs
        isCheckedCorresponsvel: false,
        isCheckedConjuge: false,
    }),
    methods: {
        normalizarFiltro(valor) {
            return String(valor ?? '').toLocaleLowerCase('pt-BR').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
        },
        normalizarDocumento(valor) {
            return String(valor ?? '').toLocaleLowerCase('pt-BR').replace(/[^a-z0-9]/g, '');
        },
        normalizarTelefone(valor) {
            return String(valor ?? '').replace(/\D/g, '');
        },
        nomeGarantidora(garId) {
            return this.ListGarantidorasGeral.find(x => x.garId == garId)?.garNomeEmpresa || '';
        },
        nomeImobiliaria(imoId) {
            return this.ListImobiliariasGeral.find(x => x.imoId == imoId)?.imoNomeEmpresa || '';
        },
        limparFiltros() {
            this.aplicarFiltrosDoUsuario();
            this.filtroNome = '';
            this.filtroDocumento = '';
            this.filtroWhatsapp = '';
            this.filtroTelefone = '';
            this.filtroEmail = '';
        },
        garantidoraFiltroAlterada() {
            this.filtroImobiliaria = null;
        },
        aplicarFiltrosDoUsuario() {
            this.filtroGarantidora = this.User.garid && this.User.garid != 0 ? this.User.garid : null;
            this.filtroImobiliaria = this.User.tpeid == 3 ? this.User.pesid : null;
        },
        async exportarClientesExcel() {
            if (!this.clientesFiltrados.length) return;
            const XLSX = await import('xlsx');

            const dados = this.clientesFiltrados.map(cliente => {
                const linha = { Id: cliente.cliId };
                if (this.User.garid == 0) linha.Garantidora = this.nomeGarantidora(cliente.garId);
                if (this.User.tpeid != 3) linha['Imobiliária'] = this.nomeImobiliaria(cliente.imoId);
                linha.Nome = cliente.cliNomeEmpresa || '';
                linha.Documento = String(cliente.cliDocumento || '');
                linha.WhatsApp = String(cliente.cliWhatsapp || '');
                linha.Telefone = String(cliente.cliTelefone || '');
                linha['E-mail'] = cliente.cliEmail || '';
                return linha;
            });

            const planilha = XLSX.utils.json_to_sheet(dados);
            planilha['!cols'] = Object.keys(dados[0]).map(campo => ({
                wch: Math.min(45, Math.max(campo.length + 2, ...dados.map(linha => String(linha[campo] ?? '').length + 2)))
            }));

            const arquivo = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(arquivo, planilha, 'Clientes');
            XLSX.writeFile(arquivo, `clientes-filtrados-${this.$moment().format('YYYY-MM-DD-HHmm')}.xlsx`);
        },
        startLoading() {
            this.isLoading = true;
        },
        stopLoading() {
            this.isLoading = false;
        },
        onReady(editor) {
            // Insert the toolbar before the editable area.
            editor.ui.getEditableElement().parentElement.insertBefore(
                editor.ui.view.toolbar.element,
                editor.ui.getEditableElement()
            );
        },
        formattedDate(value) {
            if (value != null || value != "") {
                return this.$moment(value).format('DD/MM/YYYY')
            }
            else {
                return "";
            }

        },
        formatarValor(valor) {
            return valor.toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        },
        async UploadImg(value) {
            const formData = new FormData();
            formData.append('file', value);
            const uploadResult = await axios.post(`/Telas/Clientes/upload`, formData);
            return uploadResult;
        },
         buildFileUrl(path) {
            if (!path) return '';
            const rel  = String(path).replace(/\\/g, '/'); // normaliza separadores
            const base = this.$imgURL;
            return `${base}/Telas/Clientes/GetFileByParam?param=${encodeURIComponent(rel)}&t=${Date.now()}`;
        },
        openInNewTab(path) {
            const url = this.buildFileUrl(path);
            if (!url) return;
            window.open(url, '_blank', 'noopener,noreferrer'); // nova aba
        },
         isEmailValid(email) {
            if (!email) {
            return false;
            }
            // Se houver espaços antes ou depois, rejeita
            if (email !== email.trim()) {
            return false;
            }
            // Regex simples: texto + '@' + texto + '.' + texto
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(email);
        },
        NormalizaDocumentoPessoa(pessoa, campoDocumento) {
            if (!pessoa || pessoa.tpdId !== 2 || !pessoa[campoDocumento]) return;

            const documento = pessoa[campoDocumento].toUpperCase().replace(/[^A-Z0-9./-]/g, '');
            if (documento !== pessoa[campoDocumento]) {
                pessoa[campoDocumento] = documento;
            }
        },
        NormalizaDocumento(value) {
            return String(value || '').toUpperCase().replace(/[.\-/\s]/g, '');
        },
        ValidaDocumentoPessoa(pessoa, campoDocumento) {
            if (pessoa.tpdId === 1) {
                return this.ValidaCpf(pessoa[campoDocumento]);
            }

            if (pessoa.tpdId === 2) {
                return this.ValidaCnpjAlfanumerico(pessoa[campoDocumento]);
            }

            return false;
        },
        ValidaCpf(value) {
            const cpfNormalizado = this.NormalizaDocumento(value);
            return cpf.isValid(cpfNormalizado);
        },
        ValidaCnpjAlfanumerico(value) {
            const cnpjNormalizado = this.NormalizaDocumento(value);
            if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpjNormalizado) || /^([A-Z0-9])\1{13}$/.test(cnpjNormalizado)) return false;

            const primeiroDigito = this.CalculaDigitoCnpjAlfanumerico(cnpjNormalizado.substring(0, 12));
            const segundoDigito = this.CalculaDigitoCnpjAlfanumerico(cnpjNormalizado.substring(0, 12) + primeiroDigito);

            return cnpjNormalizado.substring(12) === primeiroDigito + segundoDigito;
        },
        CalculaDigitoCnpjAlfanumerico(base) {
            const pesos = base.length === 12
                ? [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2]
                : [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

            const soma = base.split('').reduce((total, char, index) => {
                return total + (char.charCodeAt(0) - 48) * pesos[index];
            }, 0);
            const resto = soma % 11;

            return resto < 2 ? '0' : String(11 - resto);
        },
        CarregaLista() {
            this.ListClientes = this.ListClientesGeral;
        },
        //imagens
        //cliantidora
        //edit
        ValidaEstado() {
            //console.log('aquii')
            //console.log(this.Cliente.cliEstadoCivil)
            if (this.Cliente.cliEstadoCivil == 'Casado(a)' || this.Cliente.cliEstadoCivil == 'União Estável') {
                this.isCheckedConjuge = true;
            }
            else {
                this.isCheckedConjuge = false;
            }
        },
        EditNew() {
            this.EditView = true;
            this.Cliente.cliId = 0;
            this.Cliente.cliVisivel = null;
            this.Cliente.cliDataCadastro = null;
            this.Cliente.cliNomeEmpresa = '';
            this.Cliente.cliRazaoSocial = '';
            this.Cliente.tpdId = null;
            this.Cliente.cliDocumento = '';
            this.Cliente.cliTelefone = '';
            this.Cliente.cliWhatsapp = '';
            this.Cliente.cliResponsavel = '';
            this.Cliente.cliEmail = '';
            this.Cliente.cliAtivo = null;
            this.Cliente.cliDataAniversario = null;
            this.Cliente.cliCampoExtra1 = '';
            this.Cliente.cliCampoExtra2 = '';
            this.Cliente.cliCampoExtra3 = '';
            this.Cliente.cliCampoExtra4 = '';
            this.Cliente.cliCampoExtra5 = '';
            this.Cliente.cliTexto1 = '';
            this.Cliente.cliTexto2 = '';
            this.Cliente.cliTexto3 = '';
            this.Cliente.cliData1 = null;
            this.Cliente.cliData2 = null;
            this.Cliente.garId = this.User.garid == 0 ? null : this.User.garid;
            this.Cliente.imoId = this.User.tpeid == 1 ? null : this.User.tpeid == 3 ? this.User.pesid : null;
            this.Cliente.cliNomePai = '';
            this.Cliente.cliNomeMae = '';
            this.Cliente.cliNomeConjuge = '';
            this.Cliente.cliCpfConjuge = '';
            this.Cliente.cliTelefoneConjuge = '';
            this.Cliente.cliWhatsappConjuge = '';
            this.Cliente.cliEmailConjuge = '';
            this.Cliente.cliNomeCorresponsavel = '';
            this.Cliente.cliCpfCorresponsavel = '';
            this.Cliente.cliTelefoneCorresponsavel = '';
            this.Cliente.cliWhatsappCorresponsavel = '';
            this.Cliente.cliEmailCorresponsavel = '';
            this.Cliente.cliDataNascimento = '';
            this.Cliente.cliDataNamentoConjuge = '';
            this.Cliente.cliEstadoCivil = null;
            this.Cliente.cliDataNascimentoCorresponsavel = '';
            this.Cliente.cliEstadoCivilCorresponsavel = null;
            this.Cliente.cliNomePaiCorresponsavel = '';
            this.Cliente.cliNomeMaeCorresponsavel = '';
            this.Cliente.cliNomeCorresponsavel2 = '';
            this.Cliente.cliCpfCorresponsavel2 = '';
            this.Cliente.cliTelefoneCorresponsavel2 = '';
            this.Cliente.cliWhatsappCorresponsavel2 = '';
            this.Cliente.cliEmailCorresponsavel2 = '';
            this.Cliente.cliDataNascimentoCorresponsavel2 = '';
            this.Cliente.cliEstadoCivilCorresponsavel2 = null;
            this.Cliente.cliNomePaiCorresponsavel2 = '';
            this.Cliente.cliNomeMaeCorresponsavel2 = '';
            //endereco
            this.Endereco.cleId = 0;
            this.Endereco.grtId = 0;
            this.Endereco.cdtId = 0;
            this.Endereco.cleEndereco = '';
            this.Endereco.cleNumero = 0;
            this.Endereco.cleComplemento = '';
            this.Endereco.cleObsEndereco = '';
            this.Endereco.cleCep = '';
            this.Endereco.clePais = '';
            this.Endereco.cleEstado = '';
            this.Endereco.cleCidade = '';
            this.Endereco.cleBairro = '';
            this.showend = false;
            this.Retornocep = null;
            this.ListImobiliarias = [];
            if (this.User.garid != 0) {
                this.BuscaImobiliarias();
            }
            //this.ListImobiliariasGeral = [];
            //docs
            this.Docs.cdsId = 0;
            this.Docs.grtId = 0;
            this.Docs.cdtId = 0;
            this.Docs.cliId = null;
            this.Docs.cdsNomeDoc = '';
            this.Docs.cdsUrlDoc = '';
            this.Docs.cdsUser = '';
            this.Docs.cdsDataCadastro = '';
            this.selectedFile = [];
            this.DocumentosPendentes = [];
            //docs
            this.tab = 'dados';
        },
        EditCancel() {
            //window.location.reload();
            this.$router.go(0);
        },
        EditGrid(item) {
            this.EditView = true;
            this.tab = 'dados';
            //console.log('item')
            // console.log(item)
            if (item.cliId != '') {
                // Lógica clia editar o item
                axios.get(`/Telas/Clientes/GetById/` + item.cliId)
                    .then(response => {
                        this.Cliente = response.data;
                        if (this.Cliente.cliData1) {
                            this.Cliente.cliData1 = moment(this.Cliente.cliData1).format("YYYY-MM-DD");
                        }
                        if (this.Cliente.cliDataNascimento) {
                            this.Cliente.cliDataNascimento = moment(this.Cliente.cliDataNascimento).format("YYYY-MM-DD");
                        }

                        if (this.Cliente.cliDataNascimentoConjuge) {
                            this.Cliente.cliDataNascimentoConjuge = moment(this.Cliente.cliDataNascimentoConjuge).format("YYYY-MM-DD");
                        }
                        //carrecli endereços
                        this.CarregaEndereco(item.cliId);

                        //carrega imobiliarias
                        this.BuscaImobiliarias();

                        if (this.Cliente.cliEstadoCivil == 'Casado(a)' || this.Cliente.cliEstadoCivil == 'União Estável') {
                            this.isCheckedConjuge = true;
                        }

                        if (this.Cliente.cliNomeCorresponsavel != null && this.Cliente.cliNomeCorresponsavel != '') {
                            this.isCheckedCorresponsvel = true;
                        }

                        if (this.Cliente.cliNomeCorresponsavel2 != null && this.Cliente.cliNomeCorresponsavel2 != '') {
                            this.isCheckedCorresponsvel = true;
                        }

                        if (this.Cliente.cliDataNascimentoCorresponsavel) {
                            this.Cliente.cliDataNascimentoCorresponsavel = moment(this.Cliente.cliDataNascimentoCorresponsavel).format("YYYY-MM-DD");
                        }

                        if (this.Cliente.cliDataNascimentoCorresponsavel2) {
                            this.Cliente.cliDataNascimentoCorresponsavel2 = moment(this.Cliente.cliDataNascimentoCorresponsavel2).format("YYYY-MM-DD");
                        }

                        //carrecli docs
                        this.CarregaDocs(item.cliId);

                    });


            }
        },
        async Add() {
            if (this.isSubmittingAdd) return; // Proteção adicional
            this.isSubmittingAdd = true;

            if (this.Cliente.garId === '' || this.Cliente.garId === null) {
                this.$mensagemAviso("Campo Garantidora Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.imoId == '' || this.Cliente.imoId == null) {
                this.$mensagemAviso("Campo Imobiliária Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.tpdId === '' || this.Cliente.tpdId === null) {
                this.$mensagemAviso("Campo Tipo Pessoa Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliDocumento === '' || this.Cliente.cliDocumento === null) {
                this.$mensagemAviso("Campo Nº Documento Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 1 && !this.ValidaCpf(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 2 && !this.ValidaCnpjAlfanumerico(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingAdd = false;
            }
            else if (this.ListClientesGeral.filter(x => x.cliDocumento == this.Cliente.cliDocumento && x.garId == this.Cliente.garId && x.imoId == this.Cliente.imoId && x.cliId != this.Cliente.cliId).length > 0) {
                this.$mensagemAviso("Cliente ja cadastrado nesse Documento.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliNomeEmpresa == '' || this.Cliente.cliNomeEmpresa == null) {
                this.$mensagemAviso("Campo Nome Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliTelefone === '' || this.Cliente.cliTelefone === null) {
                this.$mensagemAviso("Campo Telefone Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliWhatsapp === '' || this.Cliente.cliWhatsapp === null) {
                this.$mensagemAviso("Campo Whatsapp Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliDataNascimento === '' || this.Cliente.cliDataNascimento === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Data Nascimento Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if (this.Cliente.cliEmail === '' || this.Cliente.cliEmail === null) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingAdd = false;
            }
             else if (!this.isEmailValid(this.Cliente.cliEmail)) {
                this.$mensagemAviso("E-mail Inválido.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliResponsavel === '' || this.Cliente.cliResponsavel === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo Responsável Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliCampoExtra1 === '' || this.Cliente.cliCampoExtra1 === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo CPF Responsável Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliNomePai === '' || this.Cliente.cliNomePai === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Pai Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliNomeMae === '' || this.Cliente.cliNomeMae === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Mãe Obrigatório.")
                this.isSubmittingAdd = false;
            }
            else if ((this.Cliente.cliEstadoCivil === '' || this.Cliente.cliEstadoCivil === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Estado Civil Obrigatório.")
                this.isSubmittingPut = false;
                this.isSubmittingAdd = false;
            }
            /* else if ((this.Cliente.cliNomeConjuge === '' || this.Cliente.cliNomeConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliCpfConjuge === '' || this.Cliente.cliCpfConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliTelefoneConjuge === '' || this.Cliente.cliTelefoneConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliWhatsappConjuge === '' || this.Cliente.cliWhatsappConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliEmailConjuge === '' || this.Cliente.cliEmailConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliDataNascimentoConjuge === '' || this.Cliente.cliDataNascimentoConjuge === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliTexto1 === '' || this.Cliente.cliTexto1 === null) && this.isCheckedConjuge) {
                 this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
             }
             else if ((this.Cliente.cliNomeCorresponsavel === '' || this.Cliente.cliNomeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliCpfCorresponsavel === '' || this.Cliente.cliCpfCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliTelefoneCorresponsavel === '' || this.Cliente.cliTelefoneCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliWhatsappCorresponsavel === '' || this.Cliente.cliWhatsappCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliEmailCorresponsavel === '' || this.Cliente.cliEmailCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliDataNascimentoCorresponsavel === '' || this.Cliente.cliDataNascimentoCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliEstadoCivilCorresponsavel === '' || this.Cliente.cliEstadoCivilCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliNomeMaeCorresponsavel === '' || this.Cliente.cliNomeMaeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliNomePaiCorresponsavel === '' || this.Cliente.cliNomePaiCorresponsavel === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }
             else if ((this.Cliente.cliTexto2 === '' || this.Cliente.cliTexto2 === null) && this.isCheckedCorresponsvel) {
                 this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
             }*/
            else {
                if (this.Cliente.cliVisivel === "" || this.Cliente.cliVisivel === null) {
                    this.Cliente.cliVisivel = true;
                }
                if (this.Cliente.cliAtivo === "" || this.Cliente.cliAtivo === null) {
                    this.Cliente.cliAtivo = true;
                }
                if (this.Cliente.cliDataNascimento === "" || this.Cliente.cliDataNascimento === null) {
                    this.Cliente.cliDataNascimento = null;
                }
                if (this.Cliente.cliDataNascimentoCorresponsavel === "" || this.Cliente.cliDataNascimentoCorresponsavel === null) {
                    this.Cliente.cliDataNascimentoCorresponsavel = null;
                }
                if (this.Cliente.cliDataNascimentoCorresponsavel2 === "" || this.Cliente.cliDataNascimentoCorresponsavel2 === null) {
                    this.Cliente.cliDataNascimentoCorresponsavel2 = null;
                }
                if (this.Cliente.cliDataNascimentoConjuge === "" || this.Cliente.cliDataNascimentoConjuge === null) {
                    this.Cliente.cliDataNascimentoConjuge = null;
                }
                this.Cliente.cliDataCadastro = this.$moment().format('YYYY-MM-DD')
                axios.post(`/Telas/Clientes/Add`, this.Cliente)
                    .then(response => {
                        if (response.data > 0) {
                            this.Cliente.cliId = response.data;
                            this.CarregaEndereco(this.Cliente.cliId);
                            this.$mensagemAvisoSucesso("Registro Incluído. abas clia informações adicionais liberadas.")
                        }
                    }).finally(() => {
                        this.isSubmittingAdd = false; // Libera botão ao final
                    });

            }
        },
        Put() {
            if (this.isSubmittingPut) return; // Proteção adicional
            this.isSubmittingPut = true;

            if (!this.validarEnderecoUnificado() || !this.validarDocumentoPendente()) {
                this.isSubmittingPut = false;
                return;
            }

            // console.log(this.Cliente)
            if (this.Cliente.garId === '' || this.Cliente.garId === null) {
                this.$mensagemAviso("Campo Garantidora Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.imoId == '' || this.Cliente.imoId == null) {
                this.$mensagemAviso("Campo Imobiliária Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.tpdId === '' || this.Cliente.tpdId === null) {
                this.$mensagemAviso("Campo Tipo Pessoa Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliDocumento === '' || this.Cliente.cliDocumento === null) {
                this.$mensagemAviso("Campo Nº Documento Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 1 && !this.ValidaCpf(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliDocumento != '' && this.Cliente.tpdId === 2 && !this.ValidaCnpjAlfanumerico(this.Cliente.cliDocumento)) {
                this.$mensagemAviso("Campo Nº Documento Inválido.")
                this.isSubmittingPut = false;
            }
            else if (this.ListClientesGeral.filter(x => x.cliDocumento == this.Cliente.cliDocumento && x.garId == this.Cliente.garId && x.imoId == this.Cliente.imoId && x.cliId != this.Cliente.cliId).length > 0) {
                this.$mensagemAviso("Cliente ja cadastrado nesse Documento.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliNomeEmpresa == '' || this.Cliente.cliNomeEmpresa == null) {
                this.$mensagemAviso("Campo Nome Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliTelefone === '' || this.Cliente.cliTelefone === null) {
                this.$mensagemAviso("Campo Telefone Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliWhatsapp === '' || this.Cliente.cliWhatsapp === null) {
                this.$mensagemAviso("Campo Whatsapp Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliDataNascimento === '' || this.Cliente.cliDataNascimento === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Data Nascimento Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (this.Cliente.cliEmail === '' || this.Cliente.cliEmail === null) {
                this.$mensagemAviso("Campo E-mail Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if (!this.isEmailValid(this.Cliente.cliEmail)) {
                this.$mensagemAviso("E-mail Inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliResponsavel === '' || this.Cliente.cliResponsavel === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo Responsável Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCampoExtra1 === '' || this.Cliente.cliCampoExtra1 === null) && this.Cliente.tpdId === 2) {
                this.$mensagemAviso("Campo CPF Responsável Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomePai === '' || this.Cliente.cliNomePai === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Pai Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomeMae === '' || this.Cliente.cliNomeMae === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Nome Mãe Obrigatório.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEstadoCivil === '' || this.Cliente.cliEstadoCivil === null) && this.Cliente.tpdId === 1) {
                this.$mensagemAviso("Campo Estado Civil Obrigatório.")
            }
            else if ((this.Cliente.cliNomeConjuge === '' || this.Cliente.cliNomeConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfConjuge === '' || this.Cliente.cliCpfConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfConjuge != '' && this.Cliente.cliCpfConjuge != null) && this.isCheckedConjuge && !cpf.isValid(this.Cliente.cliCpfConjuge)) {
                this.$mensagemAviso("Documento Conjuge inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTelefoneConjuge === '' || this.Cliente.cliTelefoneConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliWhatsappConjuge === '' || this.Cliente.cliWhatsappConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailConjuge === '' || this.Cliente.cliEmailConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliDataNascimentoConjuge === '' || this.Cliente.cliDataNascimentoConjuge === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTexto1 === '' || this.Cliente.cliTexto1 === null) && this.isCheckedConjuge) {
                this.$mensagemAviso("Campo Dados do Conjuge Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomeCorresponsavel === '' || this.Cliente.cliNomeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfCorresponsavel === '' || this.Cliente.cliCpfCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfCorresponsavel != '' && this.Cliente.cliCpfCorresponsavel != null) && this.isCheckedCorresponsvel && !cpf.isValid(this.Cliente.cliCpfCorresponsavel)) {
                this.$mensagemAviso("Documento Corresponsável inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTelefoneCorresponsavel === '' || this.Cliente.cliTelefoneCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliWhatsappCorresponsavel === '' || this.Cliente.cliWhatsappCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel === '' || this.Cliente.cliEmailCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if (!this.isEmailValid(this.Cliente.cliEmailCorresponsavel) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("E-mail Inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliDataNascimentoCorresponsavel === '' || this.Cliente.cliDataNascimentoCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEstadoCivilCorresponsavel === '' || this.Cliente.cliEstadoCivilCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomeMaeCorresponsavel === '' || this.Cliente.cliNomeMaeCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliNomePaiCorresponsavel === '' || this.Cliente.cliNomePaiCorresponsavel === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliTexto2 === '' || this.Cliente.cliTexto2 === null) && this.isCheckedCorresponsvel) {
                this.$mensagemAviso("Campo Dados do Corresponsável Obrigatórios.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliCpfCorresponsavel2 != '' && this.Cliente.cliCpfCorresponsavel2 != null) && this.isCheckedCorresponsvel && !cpf.isValid(this.Cliente.cliCpfCorresponsavel2)) {
                this.$mensagemAviso("Documento Corresponsável 2 inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel2 != '' && this.Cliente.cliEmailCorresponsavel2 != null) && this.isCheckedCorresponsvel && !this.isEmailValid(this.Cliente.cliEmailCorresponsavel2)) {
                this.$mensagemAviso("E-mail Corresponsável 2 inválido.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel != '' && this.Cliente.cliEmailCorresponsavel != null) && this.isCheckedCorresponsvel && this.Cliente.cliEmailCorresponsavel === this.Cliente.cliEmail){
                this.$mensagemAviso("E-mail Corresponsável não pode ser igual ao e-mail cliente.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailCorresponsavel2 != '' && this.Cliente.cliEmailCorresponsavel2 != null) && this.isCheckedCorresponsvel && this.Cliente.cliEmailCorresponsavel2 === this.Cliente.cliEmail){
                this.$mensagemAviso("E-mail Corresponsável 2 não pode ser igual ao e-mail cliente.")
                this.isSubmittingPut = false;
            }
           else if ((this.Cliente.cliEmailCorresponsavel2 != '' && this.Cliente.cliEmailCorresponsavel2 != null) && (this.Cliente.cliEmailCorresponsavel != '' && this.Cliente.cliEmailCorresponsavel != null) && this.isCheckedCorresponsvel && this.Cliente.cliEmailCorresponsavel2 === this.Cliente.cliEmailCorresponsavel){
                this.$mensagemAviso("E-mail Corresponsável 1 e 2 não podem ser iguais.")
                this.isSubmittingPut = false;
            }
            else if ((this.Cliente.cliEmailConjuge != '' && this.Cliente.cliEmailConjuge != null) && this.isCheckedConjuge && this.Cliente.cliEmailConjuge === this.Cliente.cliEmail) {
                this.$mensagemAviso("Campo e-mail do Conjuge não pode ser igual ao e-mail cliente.")
                this.isSubmittingPut = false;
            }
            else {
                if (this.Cliente.cliVisivel === "" || this.Cliente.cliVisivel === null) {
                    this.Cliente.cliVisivel = true;
                }
                if (this.Cliente.cliAtivo === "" || this.Cliente.cliAtivo === null) {
                    this.Cliente.cliAtivo = true;
                }
                if (this.Cliente.cliDataNascimentoCorresponsavel2 === '') {
                    this.Cliente.cliDataNascimentoCorresponsavel2 = null;
                }


                if (!this.isCheckedCorresponsvel) {
                    this.Cliente.cliNomeCorresponsavel = '';
                    this.Cliente.cliCpfCorresponsavel = '';
                    this.Cliente.cliTelefoneCorresponsavel = '';
                    this.Cliente.cliWhatsappCorresponsavel = '';
                    this.Cliente.cliEmailCorresponsavel = '';
                    this.Cliente.cliDataNascimentoCorresponsavel = null;
                    this.Cliente.cliEstadoCivilCorresponsavel = null;
                    this.Cliente.cliNomePaiCorresponsavel = '';
                    this.Cliente.cliNomeMaeCorresponsavel = '';
                    this.Cliente.cliNomeCorresponsavel2 = '';
                    this.Cliente.cliCpfCorresponsavel2 = '';
                    this.Cliente.cliTelefoneCorresponsavel2 = '';
                    this.Cliente.cliWhatsappCorresponsavel2 = '';
                    this.Cliente.cliEmailCorresponsavel2 = '';
                    this.Cliente.cliDataNascimentoCorresponsavel2 = null;
                    this.Cliente.cliEstadoCivilCorresponsavel2 = null;
                    this.Cliente.cliNomePaiCorresponsavel2 = '';
                    this.Cliente.cliNomeMaeCorresponsavel2 = '';
                    this.Cliente.cliTexto2 = '';
                    this.Cliente.cliTexto3 = '';
                }


                //console.log('this.Cliente')
                //console.log(this.Cliente)

                axios.put(`/Telas/Clientes/Update`, this.Cliente)
                    .then(async response => {
                        if (response.status == 200) {
                            await this.salvarEnderecoUnificado();
                            await this.salvarDocumentoPendente();
                            this.$mensagemAvisoSucesso("Cliente atualizado com sucesso.")
                            await this.Get();
                        }
                    }).finally(() => {
                        this.isSubmittingPut = false; // Libera botão ao final
                    });
            }
        },
        //edit
        DeleteGrid(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica clia excluir o item
                        const cliam1 = item.cliId;
                        axios.delete(`/Telas/Clientes/Delete/${cliam1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.Get();
                                }
                            });
                    }
                });
        },
        montaGrid() {
            this.headers = [];
            this.headers.push({ text: "Id", value: "cliId", sortable: true, });
            if (this.User.garid == 0) {
                this.headers.push({ text: "Garantidora", value: "garId", sortable: true, });
            }
            if (this.User.tpeid != 3) {
                this.headers.push({ text: "Imobiliaria", value: "imoId", sortable: true, });
            }
            this.headers.push({ text: "Nome", value: "cliNomeEmpresa", sortable: true, });
            this.headers.push({ text: "Documento", value: "cliDocumento", sortable: true, });
            this.headers.push({ text: "Whatsapp", value: "cliWhatsapp", sortable: true, });
            this.headers.push({ text: "Telefone", value: "cliTelefone", sortable: true, });
            this.headers.push({ text: "E-mail", value: "cliEmail", sortable: true, });
            this.headers.push({ text: 'Ações', value: 'actions' });
        },
        //cliantidora
        //endereco
        CarregaEndereco(_cliId) {
            axios.get(`/Telas/Clientes/GetEnderecoByCliClienteEndereco/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.Endereco = response.data[0];
                        this.showend = true;
                    }
                    else {
                        this.Endereco.cliId = _cliId;
                    }
                });
        },
        Buscacep(value) {
            if (value == "") {
                this.$mensagemAviso("Digite um CEP válido.")
            }
            else {
                fetch("https://viacep.com.br/ws/" + value + "/json/")
                    .then(response => {
                        if (!response.ok) {
                            throw new Error("CEP inexistente");
                        }
                        return response.json();
                    })
                    .then(data => {
                        this.Retornocep = data;
                        if (this.Retornocep != null) {
                            this.Endereco.cleEndereco = this.Retornocep.logradouro;
                            this.Endereco.cleNumero = null;
                            this.Endereco.cleComplemento = null;
                            this.Endereco.cleEstado = this.Retornocep.uf;
                            this.Endereco.cleCidade = this.Retornocep.localidade;
                            this.Endereco.cleBairro = this.Retornocep.bairro;
                            this.Endereco.cleCodigoDistrito = this.Retornocep.ibge;
                            this.showend = true;
                        } else {
                            this.$mensagemAviso("CEP inexistente");
                        }
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        },
        enderecoFoiInformado() {
            return !!(this.Endereco.cleId || this.Endereco.cleCep || this.Endereco.cleEndereco ||
                this.Endereco.cleNumero || this.Endereco.cleEstado || this.Endereco.cleCidade || this.Endereco.cleBairro);
        },
        validarEnderecoUnificado() {
            if (!this.enderecoFoiInformado()) return true;
            const obrigatorios = [
                ['CEP', this.Endereco.cleCep],
                ['Endereço', this.Endereco.cleEndereco],
                ['Número', this.Endereco.cleNumero],
                ['Estado', this.Endereco.cleEstado],
                ['Cidade', this.Endereco.cleCidade],
                ['Bairro', this.Endereco.cleBairro]
            ];
            const pendente = obrigatorios.find(([, valor]) => valor === '' || valor === null || valor === undefined);
            if (pendente) {
                this.$mensagemAviso(`Campo ${pendente[0]} Obrigatório.`);
                return false;
            }
            return true;
        },
        validarDocumentoPendente() {
            const possuiNome = !!String(this.Docs.cdsNomeDoc || '').trim();
            const possuiArquivo = Array.isArray(this.selectedFile) ? this.selectedFile.length > 0 : !!this.selectedFile;
            if (!possuiNome && !possuiArquivo) return true;
            if (!possuiNome) {
                this.$mensagemAviso("Digite nome do Documento a ser enviado.");
                return false;
            }
            if (!possuiArquivo) {
                this.$mensagemAviso("Selecione um Documento a ser enviado.");
                return false;
            }
            this.$mensagemAviso("Clique em Adicionar para incluir o documento na lista antes de salvar.");
            return false;
        },
        adicionarDocumentoNaMemoria() {
            const nome = String(this.Docs.cdsNomeDoc || '').trim();
            const arquivo = Array.isArray(this.selectedFile) ? this.selectedFile[0] : this.selectedFile;
            if (!nome) {
                this.$mensagemAviso("Digite o nome do documento.");
                return;
            }
            if (!arquivo) {
                this.$mensagemAviso("Selecione o arquivo do documento.");
                return;
            }
            this.DocumentosPendentes.push({ nome, arquivo });
            this.Docs.cdsNomeDoc = '';
            this.selectedFile = [];
        },
        removerDocumentoDaMemoria(index) {
            this.DocumentosPendentes.splice(index, 1);
        },
        async salvarEnderecoUnificado() {
            if (!this.enderecoFoiInformado()) return;
            this.Endereco.cliId = this.Cliente.cliId;
            if (this.Endereco.cleId) {
                await axios.put(`/Telas/Clientes/UpdateClienteEndereco`, this.Endereco);
                return;
            }
            const response = await axios.post(`/Telas/Clientes/AddClienteEndereco`, this.Endereco);
            if (response.data > 0) this.Endereco.cleId = response.data;
        },
        async salvarDocumentoPendente() {
            if (!this.DocumentosPendentes.length) return;

            while (this.DocumentosPendentes.length) {
                const documento = this.DocumentosPendentes[0];
                const arquivo = documento.arquivo;
                const upload = await this.UploadImg(arquivo);
                if (upload.status != 200) throw new Error(`Não foi possível carregar o documento ${arquivo.name}.`);

                await axios.post(`/Telas/Clientes/AddClientesDocs`, {
                    cdsId: 0,
                    grtId: 0,
                    cdtId: 0,
                    cliId: this.Cliente.cliId,
                    cdsNomeDoc: documento.nome,
                    cdsUrlDoc: upload.data.nameFile,
                    cdsUser: this.User.cusid,
                    cdsDataCadastro: moment().format("YYYY-MM-DD")
                });
                this.DocumentosPendentes.shift();
            }
            this.CarregaDocs(this.Cliente.cliId);
            this.selectedFile = [];
            this.Docs.cdsNomeDoc = '';
        },
        //endereco
        //docs
        CarregaDocs(_cliId) {
            axios.get(`/Telas/Clientes/GetBycliIdClientesDocs/` + _cliId)
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListaDocs = response.data;
                    }
                    else {
                        this.ListaDocs = [];
                    }
                });
        },
        DeleteDocumento(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
                .then((result) => {
                    if (result.isConfirmed) {
                        // Lógica para excluir o item
                        const param1 = item.cdsId;
                        axios.delete(`/Telas/Clientes/DeleteClientesDocs/${param1}`)
                            .then(response => {
                                if (response.status == 200) {
                                    this.$mensagemAvisoSucesso("Registro Excluido.")
                                    this.CarregaDocs(this.Cliente.cliId);
                                }
                            });
                    }
                });
        },
        VisualizarDocumento(item) {
            if (item && item.cdsUrlDoc) {
                // Abre o PDF em uma nova aba
               this.openInNewTab(item.cdsUrlDoc);
            } else {
                console.error("URL não está disponível.");
            }
        },
        //docs
        BuscaImobiliarias() {
            if (this.Cliente.garId === null || this.Cliente.garId === '' || this.Cliente.garId === undefined) {
                this.Cliente.imoId = null;
                this.ListImobiliariasGeral = [];
                this.ListImobiliarias = [];
                return;
            }
            axios.get(`/Telas/Clientes/GetByGarIdParIdImobilairias/` + this.Cliente.garId + '/0')
                .then(response => {
                    if (response.data.length > 0) {
                        this.ListImobiliariasGeral = response.data;
                        this.ListImobiliarias = this.ListImobiliariasGeral;
                    }
                });
        },
        async Get() {
            await axios.get(`/Telas/Clientes/GetDados`)
               .then(response => {
               this.ListGarantidorasGeral = response.data.garantidoras.filter(x => x.garVisivel);
                this.ListImobiliariasGeral = response.data.imobiliarias;
                 this.EditView = false;
                this.ListClientesGeral = response.data.clientes.filter(x => x.cliAtivo);
                this.CarregaLista();
                this.montaGrid();
                this.TiposDocumentos = response.data.tipoDocumentos.filter(x => x.tpdAtivo);
                this.User.tpeid = response.data.tpeId
                this.User.garid = response.data.garId
                this.User.pesid = response.data.pesId
                this.User.cusid = response.data.cusId;
                this.aplicarFiltrosDoUsuario();
         });
        }
    },
    created() {
        this.Get();
    },
    computed: {
        garantidorasParaFiltro() {
            return [...this.ListGarantidorasGeral].sort((a, b) =>
                String(a.garNomeEmpresa || '').localeCompare(String(b.garNomeEmpresa || ''), 'pt-BR', { sensitivity: 'base' })
            );
        },
        imobiliariasParaFiltro() {
            if (this.filtroGarantidora === null || this.filtroGarantidora === '') {
                return [];
            }
            return this.ListImobiliariasGeral
                .filter(x => x.garId == this.filtroGarantidora)
                .sort((a, b) =>
                    String(a.imoNomeEmpresa || '').localeCompare(String(b.imoNomeEmpresa || ''), 'pt-BR', { sensitivity: 'base' })
                );
        },
        imobiliariasFormulario() {
            if (!this.Cliente.garId) return [];
            return this.ListImobiliariasGeral.filter(x => x.garId == this.Cliente.garId)
                .sort((a, b) => String(a.imoNomeEmpresa || '').localeCompare(String(b.imoNomeEmpresa || ''), 'pt-BR', { sensitivity: 'base' }));
        },
        clientesFiltrados() {
            const nome = this.normalizarFiltro(this.filtroNome);
            const documento = this.normalizarDocumento(this.filtroDocumento);
            const whatsapp = this.normalizarTelefone(this.filtroWhatsapp);
            const telefone = this.normalizarTelefone(this.filtroTelefone);
            const email = this.normalizarFiltro(this.filtroEmail);

            return this.ListClientes.filter(cliente => {
                if (this.filtroGarantidora !== null && this.filtroGarantidora !== '' && cliente.garId != this.filtroGarantidora) return false;
                if (this.filtroImobiliaria !== null && this.filtroImobiliaria !== '' && cliente.imoId != this.filtroImobiliaria) return false;
                if (nome && !this.normalizarFiltro(cliente.cliNomeEmpresa).includes(nome)) return false;
                if (documento && !this.normalizarDocumento(cliente.cliDocumento).includes(documento)) return false;
                if (whatsapp && !this.normalizarTelefone(cliente.cliWhatsapp).includes(whatsapp)) return false;
                if (telefone && !this.normalizarTelefone(cliente.cliTelefone).includes(telefone)) return false;
                if (email && !this.normalizarFiltro(cliente.cliEmail).includes(email)) return false;
                return true;
            });
        },
        documentoMask() {
            return this.Cliente.tpdId === 1 ? '###.###.###-##' : 'XX.XXX.XXX/XXXX-##';
        }
    }
}
</script>

<style scoped>
.gp-client-page-heading { align-items: center; gap: 12px; margin-bottom: 20px; }
.gp-client-page-heading h3 { margin: 0; color: #102a5a; font-size: 14px; }
.gp-client-page-heading .breadcrumbs { margin: 0; }
.gp-client-tabs { min-height: 48px; margin-bottom: 2px; padding: 6px; border: 1px solid #e1d9cd; border-radius: 13px; background: #fcf8f2; }
.gp-client-tabs :deep(.v-slide-group__content) { align-items: center; gap: 5px; }
.gp-client-tabs :deep(.v-tab) { min-width: auto; min-height: 34px; padding: 0 12px; border: 1px solid transparent; border-radius: 9px; color: #68748a; font-size: 11px !important; font-weight: 700; letter-spacing: 0; text-transform: none; }
.gp-client-tabs :deep(.v-tab .v-icon) { margin-right: 6px; color: #7d8798; }
.gp-client-tabs :deep(.v-tab:hover) { background: #f3eee6; color: #102a5a; }
.gp-client-tabs :deep(.v-tab--selected) { border-color: rgba(231,121,0,.22); background: #fff0dd; color: #102a5a; box-shadow: 0 3px 10px rgba(231,121,0,.08); }
.gp-client-tabs :deep(.v-tab--selected .v-icon) { color: #bd6300; }
.gp-client-tabs :deep(.v-tab__slider) { bottom: 2px; height: 2px; border-radius: 2px; background: #e77900; }
.gp-client-tabs :deep(.v-slide-group__prev), .gp-client-tabs :deep(.v-slide-group__next) { min-width: 30px; color: #102a5a; }
.gp-client-detail-stack { display: grid; gap: 16px; padding: 18px 4px 4px; }
.gp-detail-block { overflow: hidden; border: 1px solid #e1d9cd; border-radius: 14px; background: #fffdf9; box-shadow: 0 7px 20px rgba(16,42,90,.045); }
.gp-detail-block-header { display: flex; align-items: center; gap: 11px; padding: 13px 16px; border-bottom: 1px solid #e8e1d7; background: #fcf8f2; }
.gp-detail-block-header h4 { margin: 0; color: #102a5a; font-size: 13px; font-weight: 800; }
.gp-detail-block-header p { margin: 2px 0 0; color: #68748a; font-size: 10.5px; }
.gp-detail-block-icon { width: 34px; height: 34px; display: grid; flex: 0 0 34px; place-items: center; border-radius: 10px; background: #e8eef9; color: #1d4f9f; }
.gp-detail-doc-icon { background: #fff0dd; color: #bd6300; }
.gp-detail-block > .v-form :deep(.v-container) { max-width: none; padding: 14px 16px 8px; }
.gp-related-block { margin: 16px 4px 4px; }
.gp-related-block .gp-detail-block-icon { background: #fff0dd; color: #bd6300; }
.gp-content .gp-detail-block-body { box-sizing: border-box; width: 100%; padding: 20px 20px 20px; }
.gp-doc-upload { box-sizing: border-box; width: 100%; display: grid; grid-template-columns: minmax(180px, .8fr) minmax(260px, 1.4fr) auto; gap: 12px; align-items: flex-end; padding-bottom: 16px; }
.gp-doc-upload label { display: block; margin-bottom: 5px; color: #4d586d; font-size: 11px; font-weight: 750; }
.gp-doc-file :deep(.v-field) { min-height: 38px; border-radius: 9px; background: white; font-size: 11.5px; }
.gp-doc-file :deep(.v-field__input) { min-height: 38px; padding-top: 4px; padding-bottom: 4px; }
.gp-doc-add { min-height: 38px; display: inline-flex; align-items: center; justify-content: center; gap: 5px; color: #fff; }
.gp-doc-pending { overflow: hidden; margin-bottom: 14px; border: 1px solid #ead6b9; border-radius: 11px; background: #fffaf2; }
.gp-doc-pending-title { display: flex; align-items: center; gap: 6px; padding: 8px 11px; border-bottom: 1px solid #eadfce; color: #9a5707; font-size: 10.5px; font-weight: 750; }
.gp-doc-pending .gp-doc-item { background: #fffdf9; }
.gp-doc-save-hint { min-height: 38px; display: inline-flex; align-items: center; gap: 6px; padding: 0 11px; border: 1px solid #d9e2f1; border-radius: 9px; background: #f3f6fb; color: #5f6e86; font-size: 10.5px; font-weight: 650; white-space: nowrap; }
.gp-doc-save-hint::before { content: '\2713'; color: #1d4f9f; font-size: 12px; font-weight: 900; }
.gp-doc-list { box-sizing: border-box; width: 100%; overflow: hidden; border: 1px solid #e6dfd5; border-radius: 11px; }
.gp-doc-item { display: flex; align-items: center; gap: 10px; min-height: 52px; padding: 8px 11px; border-bottom: 1px solid #eee8de; }
.gp-doc-item:last-child { border-bottom: 0; }
.gp-doc-item:hover { background: #fcf8f2; }
.gp-doc-item-icon { width: 32px; height: 32px; display: grid; flex: 0 0 32px; place-items: center; border-radius: 9px; background: #e8eef9; color: #1d4f9f; }
.gp-doc-item-info { min-width: 0; display: flex; flex: 1; flex-direction: column; }
.gp-doc-item-info strong { overflow: hidden; color: #17223b; font-size: 11.5px; text-overflow: ellipsis; white-space: nowrap; }
.gp-doc-item-info small { margin-top: 2px; color: #7b8596; font-size: 9.5px; }
.gp-doc-item-actions { display: flex; gap: 5px; }
.gp-doc-item-actions button { width: 30px; height: 30px; display: grid; place-items: center; border: 1px solid #b8c7e2; border-radius: 8px; background: white; color: #1d4f9f; }
.gp-doc-item-actions button:hover { background: #e8eef9; }
.gp-doc-item-actions .gp-doc-delete { border-color: #f1bbc2; color: #b52b3b; }
.gp-doc-item-actions .gp-doc-delete:hover { background: #fdebed; }
.gp-doc-empty { box-sizing: border-box; width: 100%; display: flex; align-items: center; justify-content: center; flex-direction: column; gap: 6px; min-height: 95px; border: 1px dashed #d8d2c8; border-radius: 11px; color: #8b94a3; font-size: 10.5px; }
.gp-client-main-actions { display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px; padding-top: 14px; border-top: 1px solid #e8e1d7; }
.gp-client-main-actions .btn { min-width: 118px; }
@media (max-width: 767.98px) {
    .gp-client-page-heading { align-items: flex-start; flex-direction: column; }
    .gp-client-tabs { padding: 5px; border-radius: 11px; }
    .gp-client-tabs :deep(.v-tab) { min-height: 32px; padding: 0 9px; font-size: 10px !important; }
    .gp-client-detail-stack { padding-top: 12px; }
    .gp-doc-upload { grid-template-columns: 1fr; }
    .gp-doc-save-hint { justify-content: center; width: 100%; white-space: normal; text-align: center; }
    .gp-client-main-actions .btn { width: 100%; }
}
.gp-client-filters {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    align-items: flex-end;
    gap: 12px;
    margin-bottom: 10px;
    padding: 14px;
    border: 1px solid #e1d9cd;
    border-left: 4px solid #e77900;
    border-radius: 12px;
    background: #fcf8f2;
}
.gp-filter-2 { grid-column: span 2; }
.gp-filter-3 { grid-column: span 3; }
.gp-filter-4 { grid-column: span 4; }
.gp-client-filter label { display: block; margin-bottom: 5px; color: #4d586d; font-size: 11px; font-weight: 750; }
.gp-client-filter :deep(.v-input) { font-size: 12px; }
.gp-client-filter :deep(.v-field) {
    min-height: 38px;
    border-radius: 9px;
    background: #fff;
    color: #17223b;
    font-size: 12px;
    --v-field-border-opacity: 1;
}
.gp-client-filter :deep(.v-field__outline) { color: #d8d2c8; opacity: 1; }
.gp-client-filter :deep(.v-field__outline__start),
.gp-client-filter :deep(.v-field__outline__notch),
.gp-client-filter :deep(.v-field__outline__end) {
    border-color: #d8d2c8 !important;
    opacity: 1 !important;
}
.gp-client-filter :deep(.v-field__outline__start) {
    width: 10px;
    border-radius: 9px 0 0 9px;
}
.gp-client-filter :deep(.v-field__outline__end) { border-radius: 0 9px 9px 0; }
.gp-client-filter :deep(.v-field__input) {
    min-height: 38px;
    padding: 4px 4px 4px 10px;
    font-size: 12px;
    line-height: 20px;
}
.gp-client-filter :deep(input.v-field__input) { padding-left: 10px !important; }
.gp-client-filter :deep(.v-field__input > input) { transform: translateY(4px); }
.gp-client-filter :deep(.v-autocomplete__selection) { min-width: 0; margin-left: 0; overflow: hidden; white-space: nowrap; transform: translateY(4px); }
.gp-client-filter :deep(.v-field__append-inner) {
    min-height: 38px;
    padding-top: 7px;
    color: #68748a;
}
.gp-client-filter :deep(.v-field--focused .v-field__outline__start),
.gp-client-filter :deep(.v-field--focused .v-field__outline__notch),
.gp-client-filter :deep(.v-field--focused .v-field__outline__end) { border-color: #1d4f9f !important; }
.gp-client-filter :deep(.v-field--disabled) { background: #f1eee9; opacity: .72; }
.gp-client-filter :deep(.v-field--disabled .v-field__outline) { color: #d8d2c8; }
.gp-client-filter-action { display: flex; align-items: flex-end; }
.gp-client-filter-action .btn { width: 100%; min-height: 38px; }
.gp-client-grid-toolbar { display: flex; align-items: center; justify-content: space-between; gap: 12px; margin: 0 2px 10px; }
.gp-client-filter-result { color: #68748a; font-size: 11.5px; font-weight: 650; }
.gp-export-button { display: inline-flex; align-items: center; gap: 6px; border: 1px solid #a9d6bf !important; background: #e7f7ef !important; color: #16724b !important; box-shadow: none !important; }
.gp-export-button:hover { border-color: #16724b !important; background: #d8f1e5 !important; }
.gp-export-button:disabled { cursor: not-allowed; opacity: .5; }
@media (max-width: 1199.98px) {
    .gp-filter-2, .gp-filter-3, .gp-filter-4 { grid-column: span 4; }
}
@media (max-width: 767.98px) {
    .gp-filter-2, .gp-filter-3, .gp-filter-4 { grid-column: 1 / -1; }
    .gp-client-grid-toolbar { align-items: stretch; flex-direction: column; }
    .gp-export-button { justify-content: center; width: 100%; }
}
.tabinfo {
    font-size: 14px;
    text-transform: capitalize;
}
</style>
